import {useEffect} from "react";

export default function useFavouritesDataChange(props) {
    const {favouritesData = [], stores = {}} = props;
    const {favouritesStore = {}} = stores;

    useEffect(() => {
        favouritesStore.favouritesDataChange(favouritesData);
    }, [favouritesData]);
}
